exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/library/modules/_wks-ext.js
// module id = 48
// module chunks = 0